import { RootState } from 'store';
import createResourceListSelectors from 'store/ResourceListSelectors';
import { BedState, ResourceListSelectors } from 'typings/state';

const selectors: ResourceListSelectors = createResourceListSelectors((state: RootState): BedState => state.bed);

export default selectors;
